import axios from "axios";

const instanceCommerce = axios.create({
  baseURL: `https://comerciosclub.lavoz.com.ar`,
  timeout: 6000,
});

export default instanceCommerce;
